(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-ad-toy-finder]');
  if (!roots.length) return;

  var familyOptions = {
    external: {
      handle: 'clitoral-stimulator',
      title: 'Your clitoral stimulator shortlist',
      summary: 'clitoral and external options',
      broaderTitle: 'Your clitoral and external pleasure shortlist',
      broaderSummary: 'clitoral, external and related pleasure options',
      linkLabel: 'Browse all clitoral stimulators'
    },
    internal: {
      handle: 'dongs-dildos',
      title: 'Your dildo shortlist',
      summary: 'dildos and insertable toys',
      broaderTitle: 'Your internal pleasure shortlist',
      broaderSummary: 'dildos, insertables and related internal toys',
      linkLabel: 'Browse all dildos'
    },
    blended: {
      handle: 'rabbit-vibrators',
      title: 'Your rabbit vibrator shortlist',
      summary: 'rabbit vibrators for internal and external stimulation',
      broaderTitle: 'Your rabbit and dual-stimulation shortlist',
      broaderSummary: 'rabbit and dual-stimulation vibrator options',
      linkLabel: 'Browse all rabbit vibrators'
    },
    penis: {
      handle: 'male-pleasure',
      title: 'Your masturbator and stroker shortlist',
      summary: 'masturbators, strokers and penis toys',
      linkLabel: 'Browse all masturbators and strokers'
    },
    anal: {
      handle: 'anal-toys',
      title: 'Your anal toy shortlist',
      summary: 'anal and prostate toys',
      linkLabel: 'Browse all anal toys'
    },
    strapon: {
      handle: 'strap-ons',
      title: 'Your strap-on shortlist',
      summary: 'strap-on harnesses, kits and toys',
      linkLabel: 'Browse all strap-ons'
    },
    bondage: {
      handle: 'fetish-bondage',
      title: 'Your bondage and sensation shortlist',
      summary: 'bondage and sensation-play products',
      linkLabel: 'Browse all bondage'
    },
    surprise: {
      handle: 'sex-toys',
      title: 'A bit of everything, as requested',
      summary: 'favourites from across the wider sex-toy range',
      linkLabel: 'Browse all sex toys'
    }
  };

  var budgets = {
    'under-50': { min: 0, max: 49.99, summary: 'under $50', strictSummary: 'priced under $50', relaxedSummary: 'products under $50' },
    '50-99': { min: 50, max: 99.99, summary: 'from $50 to $99', strictSummary: 'priced from $50 to $99', relaxedSummary: 'products from $50 to $99' },
    '100-199': { min: 100, max: 199.99, summary: 'from $100 to $199', strictSummary: 'priced from $100 to $199', relaxedSummary: 'products from $100 to $199' },
    '200-plus': { min: 200, max: Infinity, summary: 'at $200 or more', strictSummary: 'priced at $200 or more', relaxedSummary: 'products at $200 or more' },
    any: { min: 0, max: Infinity, summary: 'at any price', strictSummary: 'across all prices', relaxedSummary: 'products across all prices' }
  };

  var strictBudgetFallbacks = {
    "external": {
      "under-50": ["rechargeable-finger-vibe", "satisfyer-secret-kiss", "colt-xtreme-turbo-bullet", "essential-rechargeable-power-bullets-pink", "silicone-classic-clit-stimulator-035-seven-functio-2543", "lady-finger-ivory", "silicone-classic-clit-stimulator-035-seven-functio", "lucky-lady-dual-stimulator", "micro-butterfly-stimulator-purple"],
      "200-plus": ["womanizer-premium-2-gray", "le-wand-grey-rechargeable-massager", "the-wand-rabbit-rose"]
    },
    "internal": {
      "200-plus": ["we-vibe-sync-2-by-we-vibe", "soraya-wave-midnight-blue", "soraya-2-aqua", "lelo-enigma-deep-rose", "the-wand-rabbit-rose", "the-g-spot-rabbit-hot-pink-bling"]
    },
    "blended": {
      "under-50": ["snappy-vibrator", "waterproof-wall-bangers-deluxe-bunny", "curved-g-spot-vibrator", "sensation-g-spot-vibrator", "rabbit-vibe-love-me-dreamy-pink"],
      "200-plus": ["we-vibe-sync-2-by-we-vibe", "soraya-wave-midnight-blue", "soraya-2-aqua", "lelo-enigma-deep-rose", "the-wand-rabbit-rose", "the-g-spot-rabbit-hot-pink-bling"]
    },
    "bondage": {
      "100-199": ["scandal-bed-restraint", "fetish-fantasy-deluxe-fantasy-door-swing", "fetish-fantasy-spread-em-bar-cuff-set", "fetish-fantasy-ultimate-bed-restraint-system", "saffron-under-the-bed-restraint-system", "sr-command-suspension-cuff-set", "saffron-chained-and-tamed"]
    },
    "surprise": {
      "200-plus": ["fetish-fantasy-deluxe-shock-therapy-travel-kit", "womanizer-premium-2-gray", "we-vibe-sync-2-by-we-vibe", "lelo-tiani-3-deep-rose", "lelo-mona-wave-midnight-blue-au", "soraya-wave-midnight-blue", "soraya-2-aqua", "le-wand-grey-rechargeable-massager", "fetish-fantasy-series-ultimate-silicone-thruster-black", "lelo-enigma-deep-rose", "the-wand-rabbit-rose", "the-g-spot-rabbit-hot-pink-bling", "revo-twist-waterproof-interchangeable-rotating-and-vibrating-massager-with-remote-control", "obsidian-neon-wand-intensity-kit", "pdx-elite-fuck-o-matic-stroker", "hismith-premium-sex-machine-app-control-with-wireless-remote", "electrastim-flick-duo-stimulator-multi-pack", "couple-sex-swing-chair", "fetish-fantasy-fantasy-swing-black", "electrastim-axis-premium-versatile-controller"]
    }
  };

  var vibes = {
    easy: {
      summary: 'keeping things easy',
      keywords: ['beginner', 'beginners', 'mini', 'compact', 'slim', 'slimline', 'simple', 'classic', 'bullet', 'finger', 'starter', 'discreet', 'travel', 'petite', 'small', 'lite', 'entry', 'quickshot']
    },
    powerful: {
      summary: 'turning up the power',
      keywords: ['power', 'powerful', 'pro', 'turbo', 'thrust', 'thrusting', 'wand', 'rabbit', 'dual', 'double', 'triple', 'g-spot', 'rechargeable', 'vibrating', 'pulse', 'intense', 'strong', 'large', 'xl', 'electro', 'electroplay', 'flogger', 'paddle', 'spikes', 'nipple']
    },
    'hands-on': {
      summary: 'hands-on exploration',
      keywords: ['dildo', 'plug', 'beads', 'cuffs', 'paddle', 'rope', 'harness', 'sleeve', 'stroker', 'masturbator', 'manual', 'finger', 'bullet', 'wand', 'massager', 'teaser', 'rabbit']
    },
    together: {
      summary: 'playing together',
      keywords: ['couple', 'couples', 'partner', 'remote', 'wearable', 'strap-on', 'strap on', 'harness', 'cock ring', 'couples ring', 'duo', 'we-vibe', 'app', 'interactive', 'launch', 'restraint', 'cuffs', 'tie', 'collar', 'leash', 'tethers', 'rope', 'gag']
    }
  };

  var collectionPageSampleLimit = 3;
  var collectionPageSize = 100;
  var maximumResultCount = 10;
  var resultLimit = 24;

  var preferredBrands = [
    'womanizer',
    'fleshlight',
    'satisfyer',
    'we-vibe',
    'lelo',
    'pretty love',
    'tenga',
    'calexotics',
    'adult loves'
  ];

  var displayBrands = {
    womanizer: 'Womanizer',
    fleshlight: 'Fleshlight',
    satisfyer: 'Satisfyer',
    'we-vibe': 'We-Vibe',
    lelo: 'LELO',
    'pretty love': 'Pretty Love',
    tenga: 'TENGA',
    calexotics: 'CalExotics',
    'adult loves': 'Adult Loves'
  };
  var productRequestCache = {};

  function parseConfig(root) {
    var node = root.querySelector('[data-ad-toy-finder-config]');
    if (!node) return { rootUrl: '/', currency: 'AUD' };
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return { rootUrl: '/', currency: 'AUD' };
    }
  }

  function joinRoot(rootUrl, path) {
    var root = rootUrl || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + path.replace(/^\//, '');
  }

  function wait(milliseconds) {
    return new Promise(function (resolve) { window.setTimeout(resolve, milliseconds); });
  }

  async function fetchJson(url) {
    var response;
    for (var attempt = 0; attempt < 3; attempt += 1) {
      response = await fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (response.ok) return response.json();
      if (response.status !== 429 && response.status < 500) break;
      await wait((attempt + 1) * 350);
    }
    throw new Error('Product collection request failed');
  }

  function ajaxMoneyToDollars(value) {
    if (value === null || value === undefined || value === '') return null;
    var amount = Number(value);
    return Number.isFinite(amount) ? (amount / 100).toFixed(2) : null;
  }

  function normaliseAjaxProduct(product) {
    if (!product || !product.handle || !Array.isArray(product.variants)) return null;
    return {
      id: product.id,
      title: product.title,
      handle: product.handle,
      vendor: product.vendor,
      product_type: product.type || product.product_type,
      tags: product.tags,
      images: product.images,
      featured_image: product.featured_image,
      variants: product.variants.map(function (variant) {
        return {
          id: variant.id,
          title: variant.title,
          available: Boolean(variant.available),
          price: ajaxMoneyToDollars(variant.price),
          compare_at_price: ajaxMoneyToDollars(variant.compare_at_price)
        };
      })
    };
  }

  function fetchFallbackProduct(rootUrl, handle) {
    var url = joinRoot(rootUrl, 'products/' + encodeURIComponent(handle) + '.js');
    if (!productRequestCache[url]) {
      productRequestCache[url] = fetchJson(url)
        .then(normaliseAjaxProduct)
        .catch(function () {
          delete productRequestCache[url];
          return null;
        });
    }
    return productRequestCache[url];
  }

  async function fetchFallbackProducts(rootUrl, handles) {
    var products = [];
    var concurrency = 4;
    for (var start = 0; start < handles.length; start += concurrency) {
      var batch = await Promise.all(handles.slice(start, start + concurrency).map(function (handle) {
        return fetchFallbackProduct(rootUrl, handle);
      }));
      products = products.concat(batch.filter(Boolean));
    }
    return products;
  }

  function decisionForProduct(config, product) {
    return (config.straponDecisions || []).find(function (decision) {
      return decision.handle === product.handle && String(decision.productId) === String(product.id);
    });
  }

  function isNarrowStrapon(state) {
    return state.family === 'strapon' && ['complete_kit', 'harness_only'].indexOf(state.vibe) >= 0;
  }

  async function fetchStraponChoices(config, choice) {
    var decisions = (config.straponDecisions || []).filter(function (decision) { return decision.classification === choice; });
    var loaded = await fetchFallbackProducts(config.rootUrl, decisions.map(function (decision) { return decision.handle; }));
    if (!loaded.length && decisions.length) throw new Error('Product choices could not load');
    var products = loaded.filter(function (product) {
      var decision = decisionForProduct(config, product);
      return decision && decision.classification === choice;
    });
    return { products: products, pageCount: 0, sampledPages: [], productCount: products.length, targetHandle: '', partialFailure: loaded.length < decisions.length };
  }

  function numericHash(value) {
    var hash = 2166136261;
    var source = String(value || '');
    for (var index = 0; index < source.length; index += 1) {
      hash ^= source.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
  }

  function seededRandom(seed) {
    var value = seed >>> 0;
    return function () {
      value += 0x6D2B79F5;
      var result = value;
      result = Math.imul(result ^ (result >>> 15), result | 1);
      result ^= result + Math.imul(result ^ (result >>> 7), result | 61);
      return ((result ^ (result >>> 14)) >>> 0) / 4294967296;
    };
  }

  function createSampleSeed() {
    try {
      var values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      return values[0];
    } catch (error) {
      return Math.floor(Math.random() * 4294967296);
    }
  }

  function sampleCollectionPages(pageCount, sampleLimit, sampleKey, requiredPage) {
    var pages = [];
    for (var page = 1; page <= pageCount; page += 1) pages.push(page);
    if (pages.length <= sampleLimit) return pages;
    var random = seededRandom(numericHash(sampleKey));
    for (var index = pages.length - 1; index > 0; index -= 1) {
      var swapIndex = Math.floor(random() * (index + 1));
      var value = pages[index];
      pages[index] = pages[swapIndex];
      pages[swapIndex] = value;
    }
    var sampled = pages.slice(0, sampleLimit);
    if (requiredPage && sampled.indexOf(requiredPage) < 0) sampled[sampled.length - 1] = requiredPage;
    return sampled.sort(function (left, right) { return left - right; });
  }

  function availableVariant(product, budget, strictBudgetOnly) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var available = variants.filter(function (variant) {
      return Boolean(variant.available) && Number.isFinite(Number.parseFloat(variant.price));
    });
    if (!available.length) return null;
    available.sort(function (left, right) {
      var leftPrice = Number.parseFloat(left.price);
      var rightPrice = Number.parseFloat(right.price);
      var leftDistance = budget ? distanceFromBudget(leftPrice, budget) : 0;
      var rightDistance = budget ? distanceFromBudget(rightPrice, budget) : 0;
      return leftDistance - rightDistance || leftPrice - rightPrice;
    });
    if (budget && strictBudgetOnly && distanceFromBudget(Number.parseFloat(available[0].price), budget) !== 0) return null;
    return available[0];
  }

  function normaliseBrand(vendor) {
    var value = String(vendor || '').trim().toLowerCase().replace(/\s+/g, ' ');
    if (value === 'pretty love' || value === 'prettylove') return 'pretty love';
    if (value === 'we vibe' || value === 'wevibe') return 'we-vibe';
    if (value.indexOf('womanizer') >= 0) return 'womanizer';
    if (value.indexOf('fleshlight') >= 0) return 'fleshlight';
    if (value.indexOf('satisfyer') >= 0) return 'satisfyer';
    if (value === 'lelo' || value.indexOf('lelo ') === 0) return 'lelo';
    if (value.indexOf('tenga') >= 0) return 'tenga';
    if (value.indexOf('calexotics') >= 0 || value === 'calextics') return 'calexotics';
    if (value.indexOf('adult loves') >= 0) return 'adult loves';
    return value;
  }

  function brandPriority(product) {
    var index = preferredBrands.indexOf(normaliseBrand(product.vendor));
    return index < 0 ? preferredBrands.length : index;
  }

  function distanceFromBudget(price, budget) {
    if (price < budget.min) return budget.min - price;
    if (price > budget.max) return price - budget.max;
    return 0;
  }

  function productSearchText(product) {
    var tags = Array.isArray(product.tags) ? product.tags.join(' ') : product.tags;
    return [product.title, product.vendor, product.product_type, tags]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
  }

  function vibePriority(product, vibe) {
    var option = vibes[vibe];
    if (!option) return 0;
    var text = productSearchText(product);
    return option.keywords.reduce(function (score, keyword) {
      var escaped = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var matchesWholeTerm = new RegExp('(^|[^a-z0-9])' + escaped + '($|[^a-z0-9])').test(text);
      return score + (matchesWholeTerm ? 1 : 0);
    }, 0);
  }

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || privacy.analyticsProcessingAllowed();
    } catch (error) {
      return false;
    }
  }

  function publishAnalytics(eventName, payload) {
    if (!analyticsAllowed()) return;
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;
    try {
      var publication = analytics.publish(eventName, payload);
      if (publication && typeof publication.catch === 'function') publication.catch(function () {});
    } catch (error) {
      // Analytics must never interrupt the finder experience.
    }
  }

  function shortlist(products, budget, vibe, targetHandle, primaryHandles, strictBudgetOnly) {
    var prepared = products.map(function (product, index) {
      var variant = availableVariant(product, budget, strictBudgetOnly !== false);
      if (!variant) return null;
      var price = Number.parseFloat(variant.price);
      var distance = distanceFromBudget(price, budget);
      if (!Number.isFinite(price) || (strictBudgetOnly !== false && distance !== 0)) return null;
      return {
        product: product,
        variant: variant,
        price: price,
        index: index,
        distance: distance,
        familyPriority: primaryHandles && primaryHandles[product.handle] ? 0 : 1,
        priority: brandPriority(product),
        vibePriority: vibePriority(product, vibe)
      };
    }).filter(Boolean);

    prepared.sort(function (left, right) {
      if (left.distance !== right.distance) return left.distance - right.distance;
      if (left.familyPriority !== right.familyPriority) return left.familyPriority - right.familyPriority;
      if (left.vibePriority !== right.vibePriority) return right.vibePriority - left.vibePriority;
      if (left.priority !== right.priority) return left.priority - right.priority;
      return left.index - right.index;
    });

    var resultCount = Math.min(maximumResultCount, prepared.length);
    var items = prepared.slice(0, resultCount);
    var target = prepared.find(function (item) { return item.product.handle === targetHandle; });

    // Keep nine strongly ranked matches and reserve one rotating discovery place.
    // The target page is always fetched, so every available product has a direct
    // path into a shortlist when its price band (or Any budget) is selected.
    if (target && target.distance === 0 && !items.some(function (item) { return item.product.handle === targetHandle; })) {
      items = prepared
        .filter(function (item) { return item.product.handle !== targetHandle; })
        .slice(0, Math.max(0, resultCount - 1))
        .concat(target);
    }
    return {
      items: items,
      total: items.length
    };
  }

  function appendTextElement(parent, tagName, className, text) {
    var element = document.createElement(tagName);
    if (className) element.className = className;
    element.textContent = text;
    parent.appendChild(element);
    return element;
  }

  function productImage(product) {
    if (product.featured_image) return product.featured_image;
    if (Array.isArray(product.images) && product.images[0]) {
      return product.images[0].src || product.images[0];
    }
    return '';
  }

  function sizedProductImageUrl(imageUrl) {
    var value = String(imageUrl || '');
    if (!value || value.indexOf('cdn.shopify.com') < 0 || /[?&]width=/.test(value)) return value;
    return value + (value.indexOf('?') >= 0 ? '&' : '?') + 'width=720';
  }

  function createProductCard(item, config, formatter, position) {
    var product = item.product;
    var card = document.createElement('article');
    card.className = 'ad-toy-finder__product-card';
    card.dataset.productHandle = product.handle;
    card.dataset.position = String(position);

    var productUrl = joinRoot(config.rootUrl, 'products/' + encodeURIComponent(product.handle)) + '?variant=' + encodeURIComponent(item.variant.id);
    var gallery = document.createElement('div');
    gallery.className = 'ad-toy-finder__product-image-gallery';
    var imageUrls = (Array.isArray(product.images) ? product.images.map(function (image) { return image.src || image; }) : []).filter(Boolean);
    if (!imageUrls.length) imageUrls = [productImage(product)];
    imageUrls.forEach(function (imageUrl, imageIndex) {
      var imageLink = document.createElement('a');
      imageLink.className = 'ad-toy-finder__product-image';
      imageLink.href = productUrl;
      imageLink.dataset.adFinderProductLink = 'image';
      imageLink.setAttribute('aria-label', 'Shop ' + (product.title || 'this pick') + ', image ' + (imageIndex + 1));
      imageLink.tabIndex = imageIndex === 0 ? 0 : -1;
      if (imageIndex !== 0) imageLink.setAttribute('aria-hidden', 'true');
      var image = document.createElement('img');
      var sizedImageUrl = sizedProductImageUrl(imageUrl);
      if (imageIndex === 0) image.src = sizedImageUrl;
      else image.dataset.src = sizedImageUrl;
      image.alt = product.title || '';
      image.loading = imageIndex === 0 && position <= 4 ? 'eager' : 'lazy';
      if (imageIndex === 0 && position <= 4) image.fetchPriority = 'high';
      image.width = 480;
      image.height = 480;
      imageLink.appendChild(image);
      gallery.appendChild(imageLink);
    });
    var galleryShell = document.createElement('div');
    galleryShell.className = 'ad-toy-finder__product-gallery';
    var previous = document.createElement('button');
    previous.type = 'button';
    previous.className = 'ad-toy-finder__gallery-arrow ad-toy-finder__gallery-arrow--prev';
    previous.textContent = '‹';
    previous.setAttribute('aria-label', 'Previous image for ' + (product.title || 'this product'));
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'ad-toy-finder__gallery-arrow ad-toy-finder__gallery-arrow--next';
    next.textContent = '›';
    next.setAttribute('aria-label', 'Next image for ' + (product.title || 'this product'));
    var galleryIndex = 0;
    var imageLinks = Array.prototype.slice.call(gallery.querySelectorAll('a'));
    function revealGalleryImage(index) {
      var image = imageLinks[index] && imageLinks[index].querySelector('img');
      if (!image || !image.dataset.src) return;
      image.src = image.dataset.src;
      delete image.dataset.src;
    }
    function updateGallery() {
      revealGalleryImage(galleryIndex);
      imageLinks.forEach(function (link, index) {
        var isActive = index === galleryIndex;
        link.tabIndex = isActive ? 0 : -1;
        if (isActive) link.removeAttribute('aria-hidden');
        else link.setAttribute('aria-hidden', 'true');
      });
      previous.disabled = galleryIndex === 0;
      next.disabled = galleryIndex === imageLinks.length - 1;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      gallery.scrollTo({ left: galleryIndex * gallery.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    previous.addEventListener('click', function () {
      galleryIndex = Math.max(0, galleryIndex - 1);
      updateGallery();
    });
    next.addEventListener('click', function () {
      galleryIndex = Math.min(imageLinks.length - 1, galleryIndex + 1);
      updateGallery();
    });
    if (imageLinks.length <= 1) {
      previous.hidden = true;
      next.hidden = true;
    }
    updateGallery();
    galleryShell.appendChild(previous);
    galleryShell.appendChild(gallery);
    galleryShell.appendChild(next);
    card.appendChild(galleryShell);

    var normalisedBrand = normaliseBrand(product.vendor);
    appendTextElement(card, 'p', 'ad-toy-finder__product-vendor', displayBrands[normalisedBrand] || product.vendor || 'Adult Direct');

    var title = document.createElement('h3');
    var titleLink = document.createElement('a');
    titleLink.href = productUrl;
    titleLink.dataset.adFinderProductLink = 'title';
    titleLink.textContent = product.title || 'View product';
    title.appendChild(titleLink);
    card.appendChild(title);

    if (item.matchReason) appendTextElement(card, 'p', 'ad-toy-finder__match-reason', item.matchReason);

    var price = document.createElement('p');
    price.className = 'ad-toy-finder__product-price';
    appendTextElement(price, 'span', '', formatter.format(item.price));
    var compareAt = Number.parseFloat(item.variant.compare_at_price);
    if (Number.isFinite(compareAt) && compareAt > item.price) {
      appendTextElement(price, 's', '', formatter.format(compareAt));
    }
    card.appendChild(price);

    if (item.distance > 0) {
      appendTextElement(card, 'p', 'ad-toy-finder__price-note', 'Outside your price range');
    }

    var action = document.createElement('a');
    action.className = 'ad-toy-finder__product-action';
    action.href = productUrl;
    action.dataset.adFinderProductLink = 'cta';
    action.textContent = 'Shop this pick';
    action.setAttribute('aria-label', 'Shop ' + (product.title || 'this pick'));
    card.appendChild(action);
    return card;
  }

  async function fetchCollectionProducts(rootUrl, handle, sampleKey, sampleSeed, includeFirstPage) {
    var collectionPayload = await fetchJson(joinRoot(rootUrl, 'collections/' + handle + '.json'));
    var productCount = Number.parseInt(collectionPayload && collectionPayload.collection && collectionPayload.collection.products_count, 10);
    if (!Number.isFinite(productCount) || productCount < 0) throw new Error('Product collection is unavailable');
    if (productCount === 0) {
      return { products: [], pageCount: 0, sampledPages: [], productCount: 0, targetHandle: '', partialFailure: false };
    }
    var pageCount = Math.max(1, Math.ceil(productCount / collectionPageSize));
    var targetOrdinal = (Number(sampleSeed) >>> 0) % productCount;
    var targetPage = Math.floor(targetOrdinal / collectionPageSize) + 1;
    var targetOffset = targetOrdinal % collectionPageSize;
    var pages = sampleCollectionPages(pageCount, collectionPageSampleLimit, sampleKey, targetPage);
    if (includeFirstPage && pages.indexOf(1) < 0) {
      var replaceIndex = pages.findIndex(function (page) { return page !== targetPage; });
      if (replaceIndex >= 0) pages[replaceIndex] = 1;
      else pages.push(1);
      pages.sort(function (left, right) { return left - right; });
    }
    var products = [];
    var targetProduct = null;
    var successfulPages = [];
    var failedPages = 0;

    async function fetchPages(pageNumbers) {
      var payloads = await Promise.all(pageNumbers.map(function (page) {
        return fetchJson(joinRoot(rootUrl, 'collections/' + handle + '/products.json?limit=' + collectionPageSize + '&page=' + page))
          .then(function (payload) {
            if (!payload || !Array.isArray(payload.products)) throw new Error('Product page is unavailable');
            return payload;
          })
          .catch(function () { return null; });
      }));
      for (var index = 0; index < payloads.length; index += 1) {
        var page = pageNumbers[index];
        var payload = payloads[index];
        if (!payload) {
          failedPages += 1;
          continue;
        }
        successfulPages.push(page);
        var batch = Array.isArray(payload.products) ? payload.products : [];
        if (page === targetPage) targetProduct = batch[targetOffset] || null;
        products = products.concat(batch);
      }
    }

    await fetchPages(pages);
    if (!successfulPages.length) throw new Error('Product pages are unavailable');
    var seen = {};
    return {
      products: products.filter(function (product) {
        if (!product || !product.handle || seen[product.handle]) return false;
        seen[product.handle] = true;
        return true;
      }),
      pageCount: pageCount,
      sampledPages: successfulPages.sort(function (left, right) { return left - right; }),
      productCount: productCount,
      targetHandle: targetProduct && targetProduct.handle ? targetProduct.handle : '',
      partialFailure: failedPages > 0
    };
  }

  function mergeProducts(primaryProducts, broaderProducts) {
    var seen = {};
    return primaryProducts.concat(broaderProducts || []).filter(function (product) {
      if (!product || !product.handle || seen[product.handle]) return false;
      seen[product.handle] = true;
      return true;
    });
  }

  function resultSummaryText(family, vibe, budget, broadened, budgetRelaxed) {
    var productSummary = broadened && family.broaderSummary ? family.broaderSummary : family.summary;
    if (budgetRelaxed) {
      return 'A few more ' + productSummary + ' for ' + vibe.summary + '. Prices outside your range are marked below.';
    }
    return 'Here are available ' + productSummary + ' for ' + vibe.summary + ', ' + budget.strictSummary + '.';
  }

  function resultHeadingText(family, broadened) {
    return broadened && family.broaderTitle ? family.broaderTitle : family.title;
  }

  var finderHistoryKey = 'adToyFinderV2';

  function readFinderHistory() {
    try {
      var saved = window.history.state && window.history.state[finderHistoryKey];
      if (!saved || saved.path !== window.location.pathname || !Number.isFinite(saved.savedAt) || Date.now() - saved.savedAt > 1800000 || saved.savedAt > Date.now()) return null;
      if (!Object.prototype.hasOwnProperty.call(familyOptions, saved.family) || !Object.prototype.hasOwnProperty.call(budgets, saved.budget) || !Number.isInteger(saved.sampleSeed) || saved.sampleSeed < 0 || saved.sampleSeed > 4294967295) return null;
      var allowedVibes = saved.family === 'strapon' ? ['complete_kit', 'harness_only', 'all'] : Object.keys(vibes);
      if (allowedVibes.indexOf(saved.vibe) < 0) return null;
      return { family: saved.family, vibe: saved.vibe, budget: saved.budget, sampleSeed: saved.sampleSeed, allowNearBudget: saved.allowNearBudget === true };
    } catch (error) { return null; }
  }

  function writeFinderHistory(state, allowNearBudget) {
    try {
      var existing = window.history.state;
      if (existing !== null && (typeof existing !== 'object' || Array.isArray(existing))) return;
      var next = Object.assign({}, existing || {});
      if (!state) delete next[finderHistoryKey];
      else next[finderHistoryKey] = { path: window.location.pathname, savedAt: Date.now(), family: state.family, vibe: state.vibe, budget: state.budget, sampleSeed: state.sampleSeed, allowNearBudget: allowNearBudget === true };
      window.history.replaceState(next, '');
    } catch (error) { /* Storage restrictions must not stop shopping. */ }
  }

  function finderCollectionRoute(rootUrl, handle, budgetKey, allowNearBudget) {
    var parameters = new URLSearchParams();
    parameters.set('filter.v.availability', '1');
    var budget = budgets[budgetKey] || budgets.any;
    if (!allowNearBudget && budgetKey !== 'any') {
      if (budget.min > 0) parameters.set('filter.v.price.gte', String(budget.min));
      if (Number.isFinite(budget.max)) parameters.set('filter.v.price.lte', String(budget.max));
    }
    return joinRoot(rootUrl, 'collections/' + handle) + '?' + parameters.toString();
  }

  function init(root) {
    var config = parseConfig(root);
    var form = root.querySelector('[data-ad-finder-form]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-ad-finder-step]'));
    var progress = root.querySelector('[data-ad-finder-progress]');
    var progressLabel = root.querySelector('[data-ad-finder-progress-label]');
    var back = root.querySelector('[data-ad-finder-back]');
    var next = root.querySelector('[data-ad-finder-next]');
    var results = root.querySelector('[data-ad-finder-results]');
    var resultHeading = root.querySelector('[data-ad-finder-result-heading]');
    var resultSummary = root.querySelector('[data-ad-finder-result-summary]');
    var loading = root.querySelector('[data-ad-finder-loading]');
    var productGrid = root.querySelector('[data-ad-finder-products]');
    var loadMore = root.querySelector('[data-ad-finder-load-more]');
    var fallback = root.querySelector('[data-ad-finder-fallback]');
    var collectionLink = root.querySelector('[data-ad-finder-collection-link]');
    var restart = root.querySelector('[data-ad-finder-restart]');
    var editButtons = Array.prototype.slice.call(root.querySelectorAll('[data-ad-finder-edit]'));
    var editCancel = root.querySelector('[data-ad-finder-edit-cancel]');
    var nearBudget = root.querySelector('[data-ad-finder-near-budget]');
    if (!form || steps.length !== 3 || !results || !next) return;

    var state = { step: 1, family: '', vibe: '', budget: '', sampleSeed: createSampleSeed() };
    var editSession = null;
    var currentResultsNearBudget = false;
    var unloaded = false;
    var debugWarnings = false;
    try {
      debugWarnings = new URLSearchParams(window.location.search).get('ad_finder_debug') === '1';
    } catch (error) {
      debugWarnings = false;
    }
    var hasStarted = false;
    var resultItems = [];
    var renderedCount = 0;
    var galleryResizeFrame = 0;
    var resultRequestVersion = 0;
    var formatter;
    try {
      formatter = new Intl.NumberFormat('en-AU', { style: 'currency', currency: config.currency || 'AUD' });
    } catch (error) {
      formatter = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
    }

    function syncPreferenceQuestion() {
      var strapon = state.family === 'strapon';
      var preferenceStep = steps[1];
      preferenceStep.querySelector('legend').textContent = strapon ? 'What are you looking for?' : 'What kind of fun are you after?';
      preferenceStep.querySelector('.ad-toy-finder__hint').textContent = strapon ? 'A kit brings them together. A harness lets you choose separately.' : 'No wrong answers. Pick the vibe that sounds like you.';
      preferenceStep.querySelectorAll('[data-ad-finder-preferences]').forEach(function (group) {
        var active = group.dataset.adFinderPreferences === (strapon ? 'strapon' : 'general');
        group.hidden = !active;
        group.querySelectorAll('input').forEach(function (input) { input.disabled = !active; });
      });
      var valid = Array.prototype.some.call(preferenceStep.querySelectorAll('input:not(:disabled)'), function (input) { return input.value === state.vibe; });
      if (!valid) state.vibe = '';
      preferenceStep.querySelectorAll('input').forEach(function (input) { input.checked = !input.disabled && input.value === state.vibe; });
    }

    function updateNextLabel() {
      next.textContent = editSession
        ? state.step === 1 && !state.vibe ? 'Next: choose your preference' : 'Update my picks'
        : state.step === 3 ? 'Show me the good stuff' : state.step === 2 ? 'Next: choose a budget' : state.family === 'strapon' ? 'Next: kit or harness?' : 'Next: set the mood';
    }

    function focusCurrentLegend() {
      var legend = steps[state.step - 1].querySelector('legend');
      var stepNumber = state.step;
      var focusVersion = resultRequestVersion;
      if (legend) window.requestAnimationFrame(function () {
        if (!unloaded && !form.hidden && state.step === stepNumber && focusVersion === resultRequestVersion) legend.focus();
      });
    }

    function showStep(stepNumber, moveFocus) {
      state.step = stepNumber;
      syncPreferenceQuestion();
      root.classList.remove('ad-toy-finder--results');
      root.classList.toggle('ad-toy-finder--editing', Boolean(editSession));
      results.hidden = true;
      form.hidden = false;
      steps.forEach(function (step, index) { step.hidden = index !== stepNumber - 1; });
      progress.max = 3;
      progress.value = stepNumber;
      progress.textContent = stepNumber + ' of 3';
      progressLabel.textContent = editSession ? 'Update your pick' : 'Pick ' + stepNumber + ' of 3';
      back.hidden = Boolean(editSession) || stepNumber === 1;
      if (editCancel) editCancel.hidden = !editSession;
      updateNextLabel();
      next.disabled = !form.querySelector('[data-ad-finder-step="' + stepNumber + '"] input:checked:not(:disabled)');
      if (moveFocus) focusCurrentLegend();
    }

    function setBusy(isBusy) {
      results.setAttribute('aria-busy', String(isBusy));
      loading.hidden = !isBusy;
    }

    function showFallback(message, status) {
      root.dataset.adFinderStatus = status || 'warning';
      fallback.textContent = message;
      fallback.hidden = false;
      if (debugWarnings && window.console && typeof window.console.warn === 'function') window.console.warn('[Toy finder]', message);
    }

    function updateLoadMore() {
      if (!loadMore) return;
      var remaining = resultItems.length - renderedCount;
      loadMore.hidden = remaining <= 0;
      if (remaining > 0) loadMore.textContent = 'Show ' + Math.min(resultLimit, remaining) + ' more matches';
    }

    function renderMoreProducts() {
      var nextItems = resultItems.slice(renderedCount, renderedCount + resultLimit);
      nextItems.forEach(function (item, index) {
        productGrid.appendChild(createProductCard(item, config, formatter, renderedCount + index + 1));
      });
      renderedCount += nextItems.length;
      updateLoadMore();
    }

    function renderProducts(items) {
      productGrid.replaceChildren();
      resultItems = items;
      renderedCount = 0;
      renderMoreProducts();
    }

    function realignProductGalleries() {
      root.querySelectorAll('.ad-toy-finder__product-image-gallery').forEach(function (gallery) {
        var links = Array.prototype.slice.call(gallery.querySelectorAll('.ad-toy-finder__product-image'));
        var activeIndex = links.findIndex(function (link) { return link.getAttribute('aria-hidden') !== 'true'; });
        if (activeIndex >= 0) gallery.scrollLeft = activeIndex * gallery.clientWidth;
      });
    }

    function handleGalleryResize() {
      if (galleryResizeFrame) window.cancelAnimationFrame(galleryResizeFrame);
      galleryResizeFrame = window.requestAnimationFrame(function () {
        galleryResizeFrame = 0;
        realignProductGalleries();
      });
    }

    function handleSectionUnload(event) {
      if (!event.target || !event.target.contains(root)) return;
      unloaded = true;
      resultRequestVersion += 1;
      if (galleryResizeFrame) window.cancelAnimationFrame(galleryResizeFrame);
      window.removeEventListener('resize', handleGalleryResize);
      document.removeEventListener('shopify:section:unload', handleSectionUnload);
    }

    window.addEventListener('resize', handleGalleryResize);
    document.addEventListener('shopify:section:unload', handleSectionUnload);

    function playResultConfetti() {
      var confetti = root.querySelector('[data-ad-finder-confetti]');
      if (!confetti) return;
      confetti.replaceChildren();
      for (var index = 0; index < 18; index += 1) {
        var piece = document.createElement('i');
        piece.style.setProperty('--i', index);
        confetti.appendChild(piece);
      }
    }

    async function loadResults(requestVersion, requestedState) {
      var family = familyOptions[requestedState.family] || familyOptions.surprise;
      var budget = budgets[requestedState.budget] || budgets.any;
      var vibe = vibes[requestedState.vibe] || vibes.easy;
      var narrowStrapon = isNarrowStrapon(requestedState);
      if (narrowStrapon) family = Object.assign({}, family, { title: requestedState.vibe === 'complete_kit' ? 'Your strap-on kit picks' : 'Your harness picks' });
      resultHeading.textContent = resultHeadingText(family, false);
      resultSummary.textContent = requestedState.family === 'strapon' ? '' : resultSummaryText(family, vibe, budget, false, false);
      collectionLink.href = finderCollectionRoute(config.rootUrl, family.handle, requestedState.budget, requestedState.allowNearBudget);
      collectionLink.textContent = requestedState.budget !== 'any' && !requestedState.allowNearBudget ? 'Browse more at this budget' : family.linkLabel;
      fallback.hidden = true;
      fallback.textContent = '';
      delete root.dataset.adFinderStatus;
      productGrid.replaceChildren();
      resultItems = [];
      renderedCount = 0;
      updateLoadMore();
      delete root.dataset.adFinderFallbackHandles;
      delete root.dataset.adFinderSupplemented;
      delete root.dataset.adFinderBudgetRelaxed;
      if (nearBudget) nearBudget.hidden = true;
      setBusy(true);

      try {
        var catalogue = narrowStrapon ? await fetchStraponChoices(config, requestedState.vibe) : await fetchCollectionProducts(
          config.rootUrl,
          family.handle,
          [requestedState.sampleSeed, requestedState.family, requestedState.vibe, requestedState.budget].join(':'),
          requestedState.sampleSeed,
          true
        );
        if (requestVersion !== resultRequestVersion) return;
        root.dataset.adFinderCataloguePages = String(catalogue.pageCount);
        root.dataset.adFinderSampledPages = catalogue.sampledPages.join(',');
        root.dataset.adFinderCatalogueProducts = String(catalogue.productCount);
        root.dataset.adFinderTargetHandle = catalogue.targetHandle;
        var primaryHandles = {};
        catalogue.products.forEach(function (product) { primaryHandles[product.handle] = true; });
        var selectionProducts = catalogue.products;
        var selection = shortlist(selectionProducts, budget, requestedState.vibe, catalogue.targetHandle, primaryHandles, true);
        var broadened = false;
        var budgetRelaxed = false;

        var fallbackHandles = narrowStrapon ? [] : (strictBudgetFallbacks[requestedState.family] || {})[requestedState.budget] || [];
        if (!selection.items.length && fallbackHandles.length) {
          var fallbackProducts = await fetchFallbackProducts(config.rootUrl, fallbackHandles);
          if (requestVersion !== resultRequestVersion) return;
          selectionProducts = mergeProducts(catalogue.products, fallbackProducts);
          selection = shortlist(selectionProducts, budget, requestedState.vibe, catalogue.targetHandle, primaryHandles, true);
        }

        var nearbySelection = shortlist(selectionProducts, budget, requestedState.vibe, catalogue.targetHandle, primaryHandles, false);
        var nearbyDistance = Number.isFinite(budget.max) ? Math.max(50, budget.max - budget.min) : budget.min / 2;
        nearbySelection.items = nearbySelection.items.filter(function (item) { return item.distance <= nearbyDistance; });
        nearbySelection.total = nearbySelection.items.length;
        if (requestedState.allowNearBudget) {
          selection = nearbySelection;
          budgetRelaxed = selection.items.some(function (item) { return item.distance !== 0; });
        }
        broadened = selection.items.some(function (item) { return !primaryHandles[item.product.handle]; });
        if (broadened) {
          root.dataset.adFinderSupplemented = 'true';
          root.dataset.adFinderFallbackHandles = fallbackHandles.join(',');
        }
        if (budgetRelaxed) root.dataset.adFinderBudgetRelaxed = 'true';

        if (!selection.items.length) {
          collectionLink.href = finderCollectionRoute(config.rootUrl, family.handle, 'any', true);
          collectionLink.textContent = family.linkLabel;
          resultSummary.textContent = '';
          var emptyStatus = catalogue.partialFailure ? 'error' : 'empty';
          showFallback(catalogue.partialFailure
            ? 'Some picks couldn’t load. Try another budget or browse the full range.'
            : requestedState.budget === 'any'
              ? 'No picks available this time. Try another toy type or browse the full range.'
              : 'No matches at that price this time. Try another budget or browse the full range.', emptyStatus);
          if (nearBudget) nearBudget.hidden = !nearbySelection.items.length || requestedState.allowNearBudget;
          publishAnalytics('adult_direct:toy_finder_results_viewed', {
            version: '1',
            family: requestedState.family,
            vibe: requestedState.vibe,
            budget: requestedState.budget,
            result_count: 0,
            status: emptyStatus
          });
        } else {
          resultHeading.textContent = resultHeadingText(family, broadened);
          resultSummary.textContent = requestedState.family === 'strapon'
            ? budgetRelaxed ? 'Prices outside your range are marked below.' : ''
            : resultSummaryText(family, vibe, budget, broadened, budgetRelaxed);
          if (requestedState.family === 'strapon') selection.items.forEach(function (item) {
            var decision = decisionForProduct(config, item.product);
            if (decision) item.matchReason = decision.reason;
          });
          renderProducts(selection.items);
          root.dataset.adFinderStatus = 'ready';
          playResultConfetti();
          publishAnalytics('adult_direct:toy_finder_results_viewed', {
            version: '1',
            family: requestedState.family,
            vibe: requestedState.vibe,
            budget: requestedState.budget,
            result_count: selection.items.length,
            budget_relaxed: budgetRelaxed,
            supplemented: broadened,
            status: 'ready'
          });
        }
      } catch (error) {
        if (requestVersion !== resultRequestVersion) return;
        resultSummary.textContent = '';
        collectionLink.href = finderCollectionRoute(config.rootUrl, family.handle, 'any', true);
        collectionLink.textContent = family.linkLabel;
        showFallback('The shortlist is not loading right now. You can still browse the full range below.', 'error');
        publishAnalytics('adult_direct:toy_finder_results_viewed', {
          version: '1',
          family: requestedState.family,
          vibe: requestedState.vibe,
          budget: requestedState.budget,
          result_count: 0,
          status: 'error'
        });
      } finally {
        if (requestVersion === resultRequestVersion) setBusy(false);
      }
    }

    function focusResultHeading() {
      var focusVersion = resultRequestVersion;
      try {
        resultHeading.focus({ preventScroll: true });
      } catch (error) {
        resultHeading.focus();
      }
      window.requestAnimationFrame(function () {
        if (unloaded || results.hidden || focusVersion !== resultRequestVersion) return;
        resultHeading.scrollIntoView({ block: 'start', behavior: 'auto' });
        window.requestAnimationFrame(function () {
          if (unloaded || results.hidden || focusVersion !== resultRequestVersion) return;
          resultHeading.scrollIntoView({ block: 'start', behavior: 'auto' });
        });
      });
    }

    function answerText(key) {
      var input = Array.prototype.slice.call(form.querySelectorAll('input[type="radio"]')).find(function (option) {
        return option.name === key && option.value === state[key];
      });
      var label = input && form.querySelector('label[for="' + input.id + '"] strong');
      return label ? label.textContent : state[key];
    }

    function updateAnswerControls() {
      var labels = { family: 'toy type', vibe: 'preference', budget: 'budget' };
      editButtons.forEach(function (button) {
        var key = button.dataset.adFinderEdit;
        var answer = answerText(key);
        var value = button.querySelector('[data-ad-finder-answer]');
        if (value) value.textContent = answer;
        button.setAttribute('aria-label', 'Change ' + labels[key] + ', currently ' + answer);
      });
    }

    function restoreCheckedAnswers() {
      form.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.checked = state[input.name] === input.value;
      });
      syncPreferenceQuestion();
    }

    function revealResults() {
      root.classList.remove('ad-toy-finder--editing');
      root.classList.add('ad-toy-finder--results');
      form.hidden = true;
      results.hidden = false;
      handleGalleryResize();
      progress.value = 3;
      progress.textContent = '3 of 3';
      progressLabel.textContent = 'Your results';
      if (editCancel) editCancel.hidden = true;
      updateAnswerControls();
    }

    function showResults(allowNearBudget, moveFocus) {
      editSession = null;
      currentResultsNearBudget = allowNearBudget === true;
      writeFinderHistory(state, currentResultsNearBudget);
      var requestedState = {
        family: state.family,
        vibe: state.vibe,
        budget: state.budget,
        sampleSeed: state.sampleSeed,
        allowNearBudget: currentResultsNearBudget
      };
      var requestedFamily = familyOptions[requestedState.family] || familyOptions.surprise;
      revealResults();
      resultHeading.textContent = resultHeadingText(requestedFamily, false);
      resultRequestVersion += 1;
      if (moveFocus !== false) focusResultHeading();
      loadResults(resultRequestVersion, requestedState);
    }

    function beginEdit(button) {
      if (unloaded || results.hidden) return;
      var key = button.dataset.adFinderEdit;
      var stepNumber = { family: 1, vibe: 2, budget: 3 }[key];
      if (!stepNumber) return;
      editSession = {
        trigger: button,
        answers: { family: state.family, vibe: state.vibe, budget: state.budget },
        needsReload: results.getAttribute('aria-busy') === 'true',
        allowNearBudget: currentResultsNearBudget
      };
      resultRequestVersion += 1;
      setBusy(false);
      showStep(stepNumber, true);
    }

    function cancelEdit() {
      if (!editSession || unloaded) return;
      var session = editSession;
      state.family = session.answers.family;
      state.vibe = session.answers.vibe;
      state.budget = session.answers.budget;
      restoreCheckedAnswers();
      editSession = null;
      resultRequestVersion += 1;
      if (session.needsReload) showResults(session.allowNearBudget, false);
      else revealResults();
      session.trigger.focus();
    }

    form.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || input.type !== 'radio') return;
      if (!hasStarted) {
        hasStarted = true;
        publishAnalytics('adult_direct:toy_finder_started', { version: '1' });
      }
      if (input.name === 'family') {
        state.family = input.value;
        syncPreferenceQuestion();
      } else if (input.name === 'vibe') {
        state.vibe = input.value;
      } else if (input.name === 'budget') {
        state.budget = input.value;
      }
      publishAnalytics('adult_direct:toy_finder_answered', {
        version: '1',
        question: input.name,
        answer: input.value,
        step: state.step
      });
      next.disabled = false;
      updateNextLabel();
    });

    productGrid.addEventListener('click', function (event) {
      var link = event.target.closest('[data-ad-finder-product-link]');
      if (!link) return;
      var card = link.closest('.ad-toy-finder__product-card');
      if (!card) return;
      publishAnalytics('adult_direct:toy_finder_product_selected', {
        version: '1',
        family: state.family,
        vibe: state.vibe,
        budget: state.budget,
        product_handle: card.dataset.productHandle,
        position: Number.parseInt(card.dataset.position, 10),
        link_type: link.dataset.adFinderProductLink
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (next.disabled) return;
      if (editSession && !state.vibe) showStep(2, true);
      else if (editSession) showResults();
      else if (state.step < 3) showStep(state.step + 1, true);
      else showResults();
    });

    editButtons.forEach(function (button) {
      button.addEventListener('click', function () { beginEdit(button); });
    });
    if (editCancel) editCancel.addEventListener('click', cancelEdit);
    if (nearBudget) nearBudget.addEventListener('click', function () {
      if (!nearBudget.hidden && !results.hidden && !unloaded) showResults(true);
    });

    if (loadMore) loadMore.addEventListener('click', renderMoreProducts);

    back.addEventListener('click', function () {
      if (state.step > 1) showStep(state.step - 1, true);
    });

    restart.addEventListener('click', function () {
      resultRequestVersion += 1;
      editSession = null;
      currentResultsNearBudget = false;
      setBusy(false);
      form.reset();
      writeFinderHistory(null);
      state = { step: 1, family: '', vibe: '', budget: '', sampleSeed: createSampleSeed() };
      productGrid.replaceChildren();
      resultItems = [];
      renderedCount = 0;
      updateLoadMore();
      fallback.hidden = true;
      fallback.textContent = '';
      if (nearBudget) nearBudget.hidden = true;
      delete root.dataset.adFinderStatus;
      delete root.dataset.adFinderFallbackHandles;
      delete root.dataset.adFinderSupplemented;
      delete root.dataset.adFinderBudgetRelaxed;
      var confetti = root.querySelector('[data-ad-finder-confetti]');
      if (confetti) confetti.replaceChildren();
      showStep(1, true);
    });

    var restored = readFinderHistory();
    if (restored) {
      state.family = restored.family;
      state.vibe = restored.vibe;
      state.budget = restored.budget;
      state.sampleSeed = restored.sampleSeed;
      restoreCheckedAnswers();
      showResults(restored.allowNearBudget, false);
    } else showStep(1, false);
  }

  roots.forEach(init);
}());
